import React from 'react';
import PropTypes from 'prop-types';

import { Label, TextInput, Flex, Select } from '@sopranodesign/pulse-components';

const GRANT_TYPES = [
  { value: 'client_credentials', label: 'Client Credentials (automatic, no user)' },
  { value: 'authorization_code', label: 'Authorization Code (user consent)' }
];

const OAuth2 = ({ credentials, handleCredentialsChange }) => {
  const isAuthorizationCode = credentials.grant_type === 'authorization_code';

  const handleFieldChange = key => event => {
    handleCredentialsChange({ ...credentials, [key]: event.target.value });
  };

  const handleGrantTypeChange = option => {
    handleCredentialsChange({ ...credentials, grant_type: option.value });
  };

  return (
    <>
      <Flex col style={{ minWidth: '14rem' }}>
        <Label htmlFor="oauth2-grant-type">Grant Type</Label>
        <Select
          id="oauth2-grant-type"
          options={GRANT_TYPES}
          value={GRANT_TYPES.find(g => g.value === credentials.grant_type)}
          onChange={handleGrantTypeChange}
        />
      </Flex>
      <Flex col style={{ minWidth: '14rem' }}>
        <Label htmlFor="oauth2-client-id">Client ID</Label>
        <TextInput
          id="oauth2-client-id"
          value={credentials.client_id}
          onChange={handleFieldChange('client_id')}
        />
      </Flex>
      <Flex col style={{ minWidth: '14rem' }}>
        <Label htmlFor="oauth2-client-secret">Client Secret</Label>
        <TextInput
          id="oauth2-client-secret"
          type="password"
          placeholder="*************"
          value={credentials.client_secret}
          onChange={handleFieldChange('client_secret')}
        />
      </Flex>
      <Flex col style={{ minWidth: '14rem' }}>
        <Label htmlFor="oauth2-token-url">Token URL</Label>
        <TextInput
          id="oauth2-token-url"
          placeholder="https://auth.example.com/oauth/token"
          value={credentials.token_url}
          onChange={handleFieldChange('token_url')}
        />
      </Flex>
      {isAuthorizationCode && (
        <Flex col style={{ minWidth: '14rem' }}>
          <Label htmlFor="oauth2-authorize-url">Authorize URL</Label>
          <TextInput
            id="oauth2-authorize-url"
            placeholder="https://auth.example.com/authorize"
            value={credentials.authorize_url}
            onChange={handleFieldChange('authorize_url')}
          />
        </Flex>
      )}
      <Flex col style={{ minWidth: '14rem' }}>
        <Label htmlFor="oauth2-scopes">Scopes</Label>
        <TextInput
          id="oauth2-scopes"
          placeholder="openid profile email"
          value={credentials.scopes}
          onChange={handleFieldChange('scopes')}
        />
      </Flex>
      {isAuthorizationCode && (
        <Flex col style={{ minWidth: '14rem' }}>
          <Label htmlFor="oauth2-extra-authorize-params">Extra Authorize Parameters (JSON)</Label>
          <TextInput
            id="oauth2-extra-authorize-params"
            placeholder='{"prompt": "consent", "audience": "api.example.com"}'
            value={credentials.extra_authorize_params}
            onChange={handleFieldChange('extra_authorize_params')}
          />
        </Flex>
      )}
    </>
  );
};

OAuth2.propTypes = {
  credentials: PropTypes.shape({
    client_id: PropTypes.string,
    client_secret: PropTypes.string,
    token_url: PropTypes.string,
    grant_type: PropTypes.string,
    authorize_url: PropTypes.string,
    scopes: PropTypes.string,
    extra_authorize_params: PropTypes.string
  }).isRequired,
  handleCredentialsChange: PropTypes.func.isRequired
};

export default OAuth2;
